import { ITheme } from "../../utils/theme";

export const GridItemStyle = () => ({
  marginBottom: { xs: 2, md: 4 }
});

export const asteriskStyle = {
  color: (theme: ITheme) => theme.palette.red.A700
}